import React, { Component } from "react";
import CileSpdlOrders from "../../Components/Cile-Spdl-Orders/Cile-Spdl-Orders";
import './Cile-Shipping.scss';

class CileShippingDetails extends Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        return (
            <div className="cile-detalhes-remessa">
                <div className="row">
                    <div className="col-10">
                        <h2 className="title-1">Detalhes de Remessa - #{this.props.match.params.idRemessa}</h2>
                    </div>
                    <div className="col-2 text-right">
                        <button onClick={() => this.props.history.push(`/cile/remessas`)} className="btn btn-outline-secondary">voltar</button>
                    </div>
                    <div className="col-12">
                        <CileSpdlOrders
                            idRemessaDetalhes={this.props.match.params.idRemessa}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default CileShippingDetails;